const styles = {
  mainCard: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
    width: "100%",
    marginTop: "5px",
    marginBottom: "10px",
    fontFamily: "'Inter', 'Roboto', sans-serif",
    border: "1px solid #E5E7EB",
    position: "relative",
  },
  headerBanner: {
    minHeight: "100px",
    background: "linear-gradient(90deg, #0E78B6 0%, #2093d6 50%, #4dbdfa 100%)",
    padding: "16px 24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  headerLocationRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    gap: "6px",
    color: "rgba(255, 255, 255, 0.9)",
    maxWidth: "calc(100% - 135px)",
    textAlign: "right",
    zIndex: 10,
    "@media (max-width: 768px)": {
      maxWidth: "100%",
      width: "100%",
      textAlign: "start",
      marginBottom: "50px",
    },
  },
  headerLocationText: {
    fontSize: "16px",
    color: "#ffffff",
    fontWeight: "600",
    marginTop: "12px",
    lineHeight: 1.4,
    wordBreak: "break-word",
  },
  actionButtonsContainer: {
    display: "flex",
    gap: "10px",
    zIndex: 10,
    flexShrink: 0,
  },
  actionBtn: {
    backgroundColor: "#e9e3ef",
    color: "#5b65a5",
    fontWeight: "600",
    textTransform: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    fontSize: "13px",
    minWidth: "auto",
    height: "27px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#EDE9FE",
    },
  },
  contentWrapper: {
    padding: "0 24px 24px 24px",
    marginTop: "-50px",
    position: "relative",
    zIndex: 2,
  },
  topSection: {
    display: "flex",
    gap: "24px",
    position: "relative",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
  },
  photoSection: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  profileImageContainer: {
    width: "130px",
    height: "130px",
    borderRadius: "50%",
    border: "4px solid #fff",
    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
    overflow: "hidden",
    position: "relative",
    background: "#F3F4F6",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    padding: 0,
    outline: "none",
  },
  initialsBox: {
    fontSize: "40px",
    fontWeight: "600",
    color: "#4B5563",
  },
  editOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: "12px",
  },
  memberIdContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginTop: "12px",
    justifyContent: "center",
  },
  memberIdText: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#374151",
  },
  infoSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    paddingTop: "50px",
    marginTop: "10px",
    "@media (max-width: 768px)": {
      paddingTop: "0px",
      marginTop: "0px",
    },
  },
  nameRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "20px",
    "@media (max-width: 768px)": {
      alignItems: "center",
    },
  },
  userName: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#111827",
    lineHeight: 1.2,
    textTransform: "capitalize",
  },
  metaRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "2px",
    alignItems: "center",
    "@media (max-width: 768px)": {
      justifyContent: "center",
    },
  },
  headerRowItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  headerRowText: {
    fontSize: "15px",
    fontWeight: "700",
  },
  iconSmall: {
    fontSize: "20px",
    color: "#5b65a5",
  },
  addressText: {
    fontSize: "15px",
    color: "#111827",
    fontWeight: "700",
    lineHeight: 1.5,
  },
  bottomSection: {
    paddingTop: "5px",
  },
  gridDetailContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "12px",
  },
  gridIconWrapper: {
    paddingTop: "2px",
  },
  gridIcon: {
    fontSize: "32px",
    color: "#5b65a5",
  },
  gridTextWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  gridLabel: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#6B7280",
    textTransform: "capitalize",
    marginBottom: "2px",
    display: "block",
  },
  gridValue: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#111827",
    lineHeight: 1.2,
    display: "block",
    wordBreak: "break-word",
  },

  // Family Styles
  familySection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "2px",
  },
  familyContent: {
    display: "flex",
    alignItems: "center",
    minHeight: "24px",
  },
  familyAvatar: {
    width: "36px",
    height: "36px",
    fontSize: "12px",
    backgroundColor: "#E0E7FF",
    color: "#3730A3",
    fontWeight: "600",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  moreCount: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    backgroundColor: "#F3F4F6",
    color: "#6B7280",
    fontSize: "11px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid white",
    marginLeft: "-10px",
    zIndex: 1,
  },
  addFamilyBtn: {
    textTransform: "none",
    color: "#5b65a5",
    fontSize: "12px",
    fontWeight: "600",
    padding: "2px 8px",
    border: "1px dashed #5b65a5",
    borderRadius: "6px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "#F5F3FF",
    },
  },
};

export default styles;
